import './App.css';
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { Analytics } from "@vercel/analytics/react";

function App() {

  const specLines = [
    "> specs --cpu",
    " AMD Ryzen 7 7700X",
    "> specs --ram",
    " 32GB DDR5 (6600MHz)",
    "> specs --gpu",
    " RTX 4070 TS OC",
    "> specs --disk",
    " 1TB M.2 + 2TB HDD",
    "> specs --os",
    " Windows 11 + Nyarch Linux",
    "> specs --monitor",
    " AOC 165Hz + Acer 120Hz (24\", 1080p)",
    "> specs --kb",
    " Logitech G413 TKL SE",
    "> specs --mouse",
    " Logitech G502 Hero"
  ];

  return (
    <div>
      <div className="bg"></div>
      <div className="main-container">
        <div className="section profile-container">
          <div className="profile">
            <div id="pfp" style={{backgroundImage: process.env.PUBLIC_URL + "/nowepfp.jpg"}}></div>
            <div id="name">VerdiX094</div>
          </div>
          <div id="pronouns">(he/him)</div>
        </div>
        <div className="separator-container">
          <div className="separator"></div>
        </div>
        <div id="about" className='section'>
          <div>Hi! I'm VerdiX (formerly known as N2O4) - a Polish software/mod developer, osu! player (135k), and your typical weeb.</div>
          <div>I specialize in Unity game development and modding (the latter especially for the game Spaceflight Simulator), but sometimes I'll also code in (usually) pure C# or Python.</div>
          <div>I read almost 100% of my DMs and pings and in most cases respond to them (unless i forget to :3). My status is DND just for no notifs, don't mind it.</div>
          <div>If you need to reach out to me, but can't use Discord for whatever reason, you can send me an e-mail - I don't guarantee a response within 48 hours, but I'll most likely read (and maybe respond) to it at one point or another.</div>
        </div>
        <div className="separator-container">
          <div className="separator"></div>
        </div>
        <div id="skills" className="section">
          <div className="code">
            <div style={{color:"#4080ff"}}>{"> programming-languages"}</div>
          </div>
          <div id="languageContainer">
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/csharp/csharp-original.svg" alt="C#" />
              <div className="tooltip">
                C#
              </div>
            </div>
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/unity/unity-original.svg" alt="Unity" />
              <div className="tooltip">
                Unity
              </div>
            </div>
            <div className="languageIcon">  
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" alt="React" />
              <div className="tooltip">
                React
              </div>
            </div>
            <div className="languageIcon"> 
              <img src="htss.png" alt="HTML/CSS" />
              <div className="tooltip">
                HTML/CSS
              </div>
            </div>
            <div className="languageIcon">
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" alt="Python" />
              <div className="tooltip">
                Python
              </div>
            </div>
            <div className="languageIcon"> 
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-plain.svg" alt="Java" />
              <div className="tooltip">
                Java
              </div>
            </div>
            <div className="languageIcon"> 
              <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg" alt="C++" />
              <div className="tooltip">
                C++
              </div>
            </div>
          </div>
        </div>
        <div id="spoken-skills" className="section">
          <div className="code">
            <div style={{color:"#4080ff"}}>{"> spoken-languages"}</div>
          </div>
          <div id="spoken-languageContainer">
            <div className="languageIcon">
              <span className="spoken fi fi-pl" alt="Polish" />
              <div className="tooltip">
                Polish (native)
              </div>
            </div>
                        <div className="languageIcon">
              <span className="spoken fi fi-us" alt="Polish" />
              <div className="tooltip">
                English (fluent)
              </div>
            </div>
                        <div className="languageIcon">
              <span className="spoken fi fi-de" alt="Polish" />
              <div className="tooltip">
                German (basic)
              </div>
            </div>
                        <div className="languageIcon">
              <span className="spoken fi fi-cn" alt="Polish" />
              <div className="tooltip">
                Chinese (basic)
              </div>
            </div>
          </div>
        </div>
        <div className="separator-container">
          <div className="separator"></div>
        </div>
        <div id="specs-links-container">
          <div id="specs" className="section">
            {specLines.map(line => (
              <div className="spec code" key={line}>
                {line.startsWith("> ") && <div style={{color:"#4080ff"}}>{line}</div>}
                {!line.startsWith("> ") && <div>{line}</div>}
              </div>
            ))}
          </div>
          <div className="separator-container">
            <div className="separator"></div>
          </div>
          <div id="links" className="section">
            <a href="https://osu.ppy.sh/users/33722049" target="blank">
              <div id="osu" className="icon">
                <div className="tooltip">
                  VerdiX
                </div>
              </div>
            </a>
            <a href="https://github.com/VerdiX094" target="blank">
              <div id="github" className="icon">
                <div className="tooltip">
                  VerdiX094
                </div>
              </div>
            </a>
            <div id="discord" className="icon">
              <div className="tooltip">
                verdix094
              </div>
            </div>
            <a href="mailto:me@verdix.moe" target="blank">
              <div id="mail" className="icon">
                <div className="tooltip">
                  me@verdix.moe
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="separator-container">
          <div className="separator"></div>
        </div>
        <div className="section" id="footer">
          <div>Made with React and Vercel</div>
          <div>Background by Ksenikust</div>
          <div>Programming language icons from <a href="https://devicon.dev/" target="blank">Devicon</a></div>
          <div>Last updated: 2025-06-15</div>
        </div>
      </div>
      <Analytics/>
    </div>
  );
}

export default App;
